module.exports = __webpack_public_path__ + "img/2.e2ca39f4.png";